export const deleteUsersRole = (payload?: any) => ({
    type: "@saga/DELETE_USERS_ROLE",
    payload
});

